<template>
    <section class="app-main">
        <transition name="fade" mode="out-in">
            <!-- <router-view :key="key"></router-view> -->
            <router-view></router-view>
        </transition>
    </section>
</template>

<script>

    export default {
        name: 'AppMain',
        mounted() {
            window.onbeforeunload = function (e) {
                var storage = window.localStorage;
                // storage.clear()
            }
        }
    };
</script>

<style lang="less" scoped>
    .app-main {
        //padding: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/layouts/HeaderLayout/components/AppMain.vue